export default __webpack_public_path__ + "static/media/card-w-press@3x.364026a2.png";